import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ItemCommonModule } from '../common/item-common.module';
import { Frequency as GalaxyFrequency, Frequency } from '@vendasta/galaxy/frequency';
import { PackageContentsPopoverModule } from '../common/package-contents-popover/package-contents-popover.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { LexiconModule } from '@galaxy/lexicon';
import { RevenuePeriod } from '@vendasta/sales-orders';
import { BillingUiModule } from '@vendasta/billing-ui';
import { RevenuePeriodToGalaxyFrequency } from '../billing-term-dialog/sales-to-galaxy-frequency.pipe';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyButtonGroupModule } from '@vendasta/galaxy/button-group';

export interface DialogData {
  itemId: string;
  name: string;
  editionName: string | undefined;
  iconUrl: string;
  revenueComponent: { revenue: number; period: RevenuePeriod };
  frequency: GalaxyFrequency;
  viewOnly: boolean;
}

export interface BillingFrequencyDialogOutput {
  frequency: GalaxyFrequency;
}

@Component({
  selector: 'inventory-ui-billing-frequency-dialog',
  templateUrl: './billing-frequency-dialog.component.html',
  styleUrls: ['./billing-frequency-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ItemCommonModule,
    PackageContentsPopoverModule,
    TranslateModule,
    CommonModule,
    LexiconModule,
    MatButtonModule,
    MatDialogContent,
    BillingUiModule,
    RevenuePeriodToGalaxyFrequency,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    GalaxyFormFieldModule,
    GalaxyButtonGroupModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogModule,
  ],
})
export class BillingFrequencyDialogComponent {
  protected form!: FormGroup;
  loading$$: Subject<boolean> = new Subject<boolean>();
  protected billingFrequency!: RevenuePeriod;

  frequencyOptions = [
    { label: 'INVENTORY_UI.BILLING_FREQUENCY.ONE_TIME', value: GalaxyFrequency.ONE_TIME },
    { label: 'INVENTORY_UI.BILLING_FREQUENCY.MONTHLY', value: GalaxyFrequency.MONTHLY },
    { label: 'INVENTORY_UI.BILLING_FREQUENCY.YEARLY', value: GalaxyFrequency.YEARLY },
  ];

  constructor(
    public dialogRef: MatDialogRef<BillingFrequencyDialogComponent, BillingFrequencyDialogOutput>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
  ) {
    this.billingFrequency = this.data.revenueComponent.period;

    this.form = this.formBuilder.group({
      frequency: [data.frequency, Validators.required],
    });
  }

  public save(): void {
    const output: BillingFrequencyDialogOutput = {
      frequency: this.form.controls.frequency.value,
    };
    this.dialogRef.close(output);
  }

  protected readonly Frequency = Frequency;
}
